<template>
  <div class="error-page">
    <div class="error-page__image-wrap">
      <div class="error-page__image-el">
        <img src="/img/404/number.jpg" alt="number img" />
      </div>
      <div class="error-page__image-el error-page__image-el--spin">
        <img src="/img/404/disc.jpg" alt="disc img" />
      </div>
      <div class="error-page__image-el">
        <img src="/img/404/number.jpg" alt="number img" />
      </div>
    </div>

    <div class="error-page__title-wrap">
      <h1 class="error-page__title">{{ $t('error.page.title') }}</h1>
    </div>

    <div class="error-page__subtitle-wrap">
      <span class="error-page__subtitle" v-html="$t('error.page.subtitle')"></span>
    </div>

    <div class="error-page__links-wrap">
      <custom-button
        v-for="link in links"
        :key="link.title"
        :href="link.url"
        type="pseudo-link"
        class="error-page__link"
      >
        {{ link.title }}
      </custom-button>
    </div>

    <rendered-blocks uid="not-found" without-container></rendered-blocks>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { EsputnikService } from '@/services/AnalyticService'

import CustomButton from '@/components/inputs/Button'
import RenderedBlocks from '@/components/rendered-blocks/RenderedBlocks'

export default {
  name: 'ErrorPage',
  components: {
    RenderedBlocks,
    CustomButton
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      userDataFromServer: state => state.user.user_data
    }),
    links () {
      return [
        {
          title: this.$t('error.page.link.main'),
          url: `${this.urlLanguagePrefix}/`
        },
        {
          title: this.$t('error.page.link.sale'),
          url: `${this.urlLanguagePrefix}/sale/`
        },
        {
          title: this.$t('error.page.link.bonuses'),
          url: `${this.urlLanguagePrefix}/loyalty-program/`
        }
      ]
    }
  },
  created () {
    EsputnikService.sendErrorPageInfo()
  }
}
</script>

<style scoped lang="sass">
.error-page
  width: 100%

.error-page__image-wrap
  width: 100%
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center
  padding: 0 15px
  pointer-events: none
  touch-action: none
  user-select: none

.error-page__image-el

  &--spin
    z-index: -1
    animation-name: spin
    animation-direction: reverse
    animation-duration: 4000ms
    animation-iteration-count: infinite
    animation-timing-function: linear

.error-page__title-wrap
  margin: 40px 0 0
  padding: 0 40px

.error-page__title
  font-size: 20px
  font-weight: 500
  letter-spacing: 0.02em
  text-transform: uppercase
  text-align: center

  +mmin($tablet--hor)
    font-size: 28px

.error-page__subtitle-wrap
  margin: 20px 0 0
  padding: 0 30px

.error-page__subtitle
  display: block
  font-size: 16px
  line-height: 150%
  text-align: center

.error-page__links-wrap
  display: flex
  flex-flow: nowrap
  align-items: center
  justify-content: center
  margin: 30px 0 0

  +mmin($tablet--hor)
    margin: 20px 0 0

.error-page__link
  font-size: 16px
  -webkit-appearance: none

  &:not(:last-child)
    margin-right: 40px

@keyframes spin
  from
    transform: rotate(0deg)

  to
    transform: rotate(360deg)

</style>
